// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-container {
  gap: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 10px;
}

.section {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: calc(100% - 20px);
  max-width: 720px;
  padding: 10px;
  gap: 10px;
  background: #ebd9cd;
  border-radius: 16px;
}
.section-row {
  flex-direction: row;
}

.section__title {
  font-size: 18px;
  line-height: 18px;
  font-weight: bold;
}

.country-flag {
  font-family: "Twemoji Country Flags", "Segoe UI Emoji", "Noto Color Emoji", sans-serif;
  text-shadow: -0.5px -0.5px 0 #3E5879, 0.5px -0.5px 0 #3E5879, -0.5px 0.5px 0 #3E5879, 0.5px 0.5px 0 #3E5879;
}

@media (max-width: 720px) {
  .hide-below-720 {
    display: none !important;
  }
}

.show-below-720 {
  display: none;
}
@media (max-width: 720px) {
  .show-below-720 {
    display: initial;
  }
}`, "",{"version":3,"sources":["webpack://./src/App.scss","webpack://./src/utils/_themeConstants.scss"],"names":[],"mappings":"AAEA;EACE,SAAA;EAEA,aAAA;EACA,sBAAA;EACA,mBAAA;EAEA,YAAA;AAHF;;AAMA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EAEA,wBAAA;EACA,gBAAA;EAEA,aAAA;EACA,SAAA;EAEA,mBClBY;EDmBZ,mBAAA;AANF;AAQE;EACE,mBAAA;AANJ;;AAUA;EACE,eAAA;EACA,iBAAA;EACA,iBAAA;AAPF;;AAUA;EACE,sFAAA;EAEA,2GACA;AATF;;AAgBE;EADF;IAEI,wBAAA;EAZF;AACF;;AAeA;EACE,aAAA;AAZF;AAaE;EAFF;IAGI,gBAAA;EAVF;AACF","sourcesContent":["@use \"./utils/themeConstants\";\r\n\r\n.main-container {\r\n  gap: 10px;\r\n\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n\r\n  margin: 10px;\r\n}\r\n\r\n.section {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: flex-start;\r\n\r\n  width: calc(100% - 20px);\r\n  max-width: 720px;\r\n\r\n  padding: 10px;\r\n  gap: 10px;\r\n\r\n  background: themeConstants.$color-light;\r\n  border-radius: 16px;\r\n\r\n  &-row {\r\n    flex-direction: row;\r\n  }\r\n}\r\n\r\n.section__title {\r\n  font-size: 18px;\r\n  line-height: 18px;\r\n  font-weight: bold;\r\n}\r\n\r\n.country-flag {\r\n  font-family: 'Twemoji Country Flags', 'Segoe UI Emoji', 'Noto Color Emoji', sans-serif;\r\n  $flag-outline-color: themeConstants.$color-dark-highlight;\r\n  text-shadow: \r\n  -0.5px -0.5px 0 $flag-outline-color,\r\n   0.5px -0.5px 0 $flag-outline-color,\r\n  -0.5px  0.5px 0 $flag-outline-color,\r\n   0.5px  0.5px 0 $flag-outline-color;\r\n}\r\n\r\n.hide-below-720 {\r\n  @media(max-width: 720px) {\r\n    display: none !important;\r\n  }\r\n}\r\n\r\n.show-below-720 {\r\n  display: none;\r\n  @media(max-width: 720px) {\r\n    display: initial;\r\n  }\r\n}","$color-dark: #213555;\r\n$color-dark-highlight: #3E5879;\r\n\r\n$color-medium: #D8C4B6;\r\n\r\n$color-light: #ebd9cd;\r\n$color-light1: #f1e2d7;\r\n\r\n$color-bright: #F5EFE7;\r\n$color-brightest: #fff9f2;\r\n\r\n$mobile-cutoff-width: 720px;"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
